import { STORABLE_DAYS } from '../../delivery-points/types/delivery-point-day.type';
import { DeliveryCitySlot } from '../types/delivery-city.type';

export const DELIVERY_CITY_NAME_MIN_LENGTH = 2;

export const DELIVERY_CITY_NAME_MAX_LENGTH = 100;

export const DELIVERY_CITY_NAME_ERROR = `Entre ${DELIVERY_CITY_NAME_MIN_LENGTH} et ${DELIVERY_CITY_NAME_MAX_LENGTH} caractères`;

export const DELIVERY_CITY_PLACE_HINT =
  'Sélectionnez la ville dans la liste proposée pour remplir le nom et le code postal';

export const SLOT_TIME_ERROR = 'Les deux heures sont obligatoires';

export const SLOT_ORDER_ERROR = "L'heure de fin doit être après l'heure de début";

export const SLOT_DUPLICATE_ERROR = 'Ce créneau existe déjà';

const TIME_PATTERN = /^([01]\d|2[0-3]):[0-5]\d$/;

export const isDeliveryCityNameValid = (name: string): boolean => {
  const trimmedLength = name.trim().length;
  return trimmedLength >= DELIVERY_CITY_NAME_MIN_LENGTH && trimmedLength <= DELIVERY_CITY_NAME_MAX_LENGTH;
};

const slotKey = (slot: DeliveryCitySlot): string => `${slot.day}|${slot.from}|${slot.to}`;

const hasValidTimes = (slot: DeliveryCitySlot): boolean => TIME_PATTERN.test(slot.from) && TIME_PATTERN.test(slot.to);

export const getSlotErrors = (slots: DeliveryCitySlot[]): (string | null)[] =>
  slots.map((slot, index) => {
    if (!hasValidTimes(slot)) return SLOT_TIME_ERROR;
    if (slot.to <= slot.from) return SLOT_ORDER_ERROR;
    if (slots.findIndex((other) => slotKey(other) === slotKey(slot)) !== index) return SLOT_DUPLICATE_ERROR;
    return null;
  });

export const areSlotsValid = (slots: DeliveryCitySlot[]): boolean =>
  getSlotErrors(slots).every((error) => error === null);

export const sortSlots = (slots: DeliveryCitySlot[]): DeliveryCitySlot[] =>
  [...slots].sort(
    (left, right) =>
      STORABLE_DAYS.indexOf(left.day) - STORABLE_DAYS.indexOf(right.day) || left.from.localeCompare(right.from)
  );
